module.exports = {"532501001":"城区街道","532501101":"锡城镇","532501102":"沙甸镇","532501103":"鸡街镇","532501104":"大屯镇","532501106":"老厂镇","532501107":"卡房镇","532501108":"蔓耗镇","532501202":"贾沙乡","532501203":"保和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532501.json
// module id = 2624
// module chunks = 0